<template>
  <div class='content'>
    <div class='poster-center'>
      <div class="top-title">
        搜索“<span class="prod-color">昆仑健康保(普惠多倍版)重疾险</span>”，共搜索<span class="num-color">10</span>条结果<span class="num-color cha">X</span>
      </div>
      <div class="top-box">
        <div class="header-tab">
          <div v-for="(item,index) in navTab" :key="index" :class="index==activeNum?'active':''" @click="tabChange(index)">{{item}}（{{1}}）</div>
        </div>
      </div>
      <productDownload v-if="activeNum==0" ref="productDownloadRef"></productDownload>
      <articleList v-if="activeNum==1" ref="articleListRef"></articleList>
      <productVideo v-if="activeNum==2" ref="productVideoRef"></productVideo>
      <posterCenter v-if="activeNum==3" ref="posterCenterRef"></posterCenter>
    </div>
  </div>
</template>
<script>
import productDownload from './productDownload'
import articleList from './articleList'
import productVideo from './productVideo'
import posterCenter from './posterCenter'
export default {
  data: () => ({
    activeNum: 0,
    navTab: ['文件', '文章课程', '视频', '海报'],
  }),
  components: {
    productDownload,
    articleList,
    productVideo,
    posterCenter,
  },
  created() {},
  methods: {
    tabChange(){
    },
  },
}
</script>
<style lang='scss' scoped>
.content {
  padding: 30px 30px 120px 30px;
  min-width: 990px;
  background: #ffffff;
  .poster-center {
    .top-title {
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      margin-bottom: 20px;
      .prod-color {
        font-size: 16px;
        color: rgba(253, 146, 1, 1);
        font-family: PingFangSC-Regular;
      }
      .num-color {
        color: rgba(253, 88, 1, 1);
      }
      .cha{
        cursor: pointer;
        margin-left: 10px;
      }
    }
    .top-box {
      display: flex;
      justify-content: space-between;
      min-height: 50px;
      border-radius: 4px;
      background: #f7f7f7;
      .header-tab {
        display: flex;
        width: 65%;
        align-items: baseline;
        div {
          flex: 1;
          display: inline-block;
          text-align: center;
          line-height: 48px;
          cursor: pointer;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
        }
        div:nth-of-type(1) {
          margin-left: 0;
        }
        .active {
          border-top: 2px solid #f7f7f7;
          border-right: 2px solid #f7f7f7;
          border-left: 2px solid #f7f7f7;
          background: #ffffff;
          border-radius: 4px 4px 0px 0px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #fd9201;
        }
      }
    }
  }
}
</style>